import { Component } from '@angular/core';

@Component({
    selector: 'app-annual-summary-tabs',
    templateUrl: './annual-summary-tabs.component.html',
    styleUrls: [],
    standalone: false
})
export class AnnualSumaryTabsComponent {
  routes = [
    { label: 'M. 180', link: 'model180', enable: true },
    { label: 'M. 184', link: 'model184', enable: true },
    { label: 'M. 193', link: 'model193', enable: true },
    { label: 'M. 182', link: 'model182', enable: true },
  ];
}
